<template>
    <div>

<div class="text-right">
<a :href="'/download/'+application.id" class="btn btn-primary mr-2" v-if="user.account == 'User'">Download application</a>
<a href="#/" class="btn btn-success" v-if="user.account == 'User'" @click="showModal()">Update status</a>
</div>



<b-modal id="bv-modal-example" hide-footer>
    <template #modal-title>
      Update application status
    </template>
    
    
<div>
  <div>
    <div>

      <div>
          
          <div class="row"><div class="col"><div class="form-group"><label for="dealer-name" class="form-label font-weight-bold">Status</label> 
      
                    <v-select 
                    v-model="status"
                    :options="statuses"
                    label="race">
                    <template #option="{ race }">
                        <span>{{ race }}</span>
                    </template>
                    </v-select>
                
    </div></div></div> 
    
    <div class="row" v-if="status == 'Cancelled'">
        <div class="col"><div class="form-group">
        
        <label for="fullname" class="form-label font-weight-bold">Reason</label> 
        
                    <v-select 
                    v-model="description"
                    :options="descriptions"
                    label="race">
                    <template #option="{ race }">
                        <span>{{ race }}</span>
                    </template>
                    </v-select>
        
        </div></div></div>
        
        </div>
      <div>
<button v-if="updating" type="button" class="btn btn-success col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>Updating status ...</button>
        <button v-else type="button" class="btn btn-success col" @click="updateStatus">Update status</button>
      </div>
    </div>
  </div>
</div>

  </b-modal>

    </div>
</template>

<script>
export default {
  props: ["user","application"],

  data() {
    return {
        updating: false,
        status: '',
        description: '',
        statuses: ['New','In Progress','Completed','Cancelled'],
        descriptions: ['Property has been taken','Duplicate application','Invalid application'],
    };
  },

  mounted() { 

    
  },

  created() {

    // this.getApplicationInfo();

  },

  methods: {

    showModal() {
        this.status = '';
        this.description = '';
        
        this.$bvModal.show('bv-modal-example');
      },

      hideModal() {
        this.$bvModal.hide('bv-modal-example');
      },

      updateStatus() {
        if (this.status == '' || this.status == null) {this.sweetfire('Please choose a status')}
        else if (this.status=='Cancelled' && (this.description=='' || this.description == null)) {this.sweetfire('Please choose a reason')}

        else {

          this.updating = true;

          axios.post('/application/updates/new', {application_id: this.application.id, status: this.status, description: this.description})
        .then((response) => {
          console.log(response.data);
          this.hideModal();
          this.updating = false;

        })
        .catch(function (error) {
          console.log(error);
          this.updating = false;
        });

        }

      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },

  },
};
</script>